import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import GridContainer from 'components/Grid/GridContainer.js';

import General from './General';
import Rules from './Rules';
import Groups from './Groups';
import ZoneCanal from './ZoneCanal';
import Customer from './Customer';

import { wsGet } from 'services/WService';
import { Toasty, useToasty } from 'hooks/Toasty';
import BusinessLines from './BusinessLines';
import PromotionBureaus from './PromotionBureaus';

export default function PromotionShow() {
  const { id } = useParams();
  const [defaultBusinessLinesProvider, setDefaultBusinessLinesProvider] = useState(-1);
  const [promotion, setPromotion] = useState({});
  const [bureaus, setBureaus] = useState([]);
  const [currentRule, setCurrentRule] = useState(undefined);
  const [notify, showNotify] = useToasty();

  async function getPromotion() {
    let response = await wsGet('prom/promotion', id);
    if (response.success) {
      setPromotion(response.data);
      setBureaus(response.data.bureaus);
      setDefaultBusinessLinesProvider(response.default_provider_business_line || 0);
    }
  }

  const [existSaleGroup, setCurrentSellGroup] = useState(false);
  const [existBoniGroup, setCurrentBoniGroup] = useState(false);
  const [currentRest, setCurrentRest] = useState(false);

  useEffect(() => {
    getPromotion();
  }, []);
  //NG
  return (
    <GridContainer>
      <Toasty action={notify} />

      <General
        isNew={id == 0 ? true : false}
        promotionInitial={promotion}
        reload={getPromotion}
        existSaleGroup={existSaleGroup} //estado de grupo-venta
        existBoniGroup={existBoniGroup} //estado de grupo-bonificación
        showNotify={showNotify}
      />
      {promotion.only_business_lines === 'Y' ? (
        <BusinessLines
          promotion={promotion}
          showNotify={showNotify}
          getPromotion={getPromotion}
          defaultBusinessLinesProvider={defaultBusinessLinesProvider}
        />
      ) : undefined}

      {id != 0 && !!promotion.id && promotion.description !== '' ? (
        <Rules promotion={promotion} setRule={setCurrentRule} setPromotion={setPromotion} />
      ) : (
        <div style={{ width: '100%' }}>
          <h3 style={{ textAlign: 'center' }}>Ingrese la información para continuar...</h3>
          <p style={{ textAlign: 'center' }}>
            Los campos Descripción y Proveedor son necesarios para una promoción.
          </p>
        </div>
      )}

      {!!currentRule && (
        <Groups
          rule={currentRule}
          promotion={promotion}
          showNotify={showNotify}
          reloadPromo={getPromotion}
          setCurrentSellGroup={setCurrentSellGroup}
          setCurrentBoniGroup={setCurrentBoniGroup}
        />
      )}

      {existSaleGroup || existBoniGroup ? (
        <ZoneCanal promotion={promotion} setCurrentRest={setCurrentRest} showNotify={showNotify} />
      ) : undefined}

      <PromotionBureaus promotion={promotion} bureaus={bureaus} setBureaus={setBureaus} />

      {currentRest ? <Customer promotion={promotion} /> : undefined}
    </GridContainer>
  );
}
